import { ChangeEvent, useState } from "react";
import { useAppDispatch } from "../useAppDispatch";
import {
    AddressForm,
    AutocompleteAddressParams,
} from "../../domain/models/dto/AddressDTO";
import {
    AUTOCOMPLETE_LIMIT,
    DEFAULT_OFFSET,
    DEFAULT_PAGE,
} from "../../domain/constants";
import { AutocompleteServiceImpl } from "../../services/AutocompleteServiceImpl";
import _ from "lodash";
import { FormikProps } from "formik";

// TODO :: use something any instead.. any.
function useAutocompletedAddress(form: FormikProps<any>) {
    const dispatch = useAppDispatch();

    const [countries, setCountries] = useState<string[]>([]);
    const [cities, setCities] = useState<string[]>([]);
    const [addresses, setAddresses] = useState<string[]>([]);

    const autocompleteAddress =
        (field: keyof AddressForm) =>
        async (e: ChangeEvent<HTMLInputElement>) => {
            const params: AutocompleteAddressParams = {
                page: DEFAULT_PAGE,
                limit: AUTOCOMPLETE_LIMIT,
                offset: DEFAULT_OFFSET,
                country: _.get(form.values, "address.country"),
                city: _.get(form.values, "address.city"),
                address: _.get(form.values, "address.address"),
            };
            params[field] = e.target.value;

            const result = ((
                await dispatch(
                    AutocompleteServiceImpl.getAutocompletedAddressDataThunk(
                        params
                    )
                )
            )?.payload || []) as AddressForm[];

            if (field === "country") {
                setCountries(
                    _.uniq(
                        result
                            .map((item) => item.country)
                            .filter((item) => !!item)
                    )
                );
                setCities([]);
                setAddresses([]);
            }
            if (field === "city") {
                setCities(
                    _.uniq(
                        result.map((item) => item.city).filter((item) => !!item)
                    )
                );
                setAddresses([]);
            }
            if (field === "address") {
                setAddresses(
                    _.uniq(
                        result
                            .map((item) => item.address)
                            .filter((item) => !!item)
                    )
                );
            }
        };

    return {
        countries,
        cities,
        addresses,

        autocompleteAddress,

        resetCountries: () => setCountries([]),
        resetCities: () => setCities([]),
        resetAddresses: () => setAddresses([]),

        selectCountry: (value: string) =>
            form.setFieldValue("address.country", value),
        selectCity: (value: string) =>
            form.setFieldValue("address.city", value),
        selectAddress: (value: string) =>
            form.setFieldValue("address.address", value),
    };
}

export default useAutocompletedAddress;
